import React, { useState, useEffect } from 'react'
import { bool, func, node, oneOf, string } from 'prop-types'
import Link from 'next/link'

const SmartLink = ({
  as,
  children,
  className,
  disabled,
  href,
  role,
  setRef,
  target,
  to,
  type,
  prefetch,
  ...other
}) => {
  const pid = other && other['data-pid']
  const [previewId, setPreviewId] = useState(pid)

  useEffect(() => {
    if (typeof window !== 'undefined' && !pid) {
      const currentUrl = new URL(window.location.href)
      const searchParams = new URLSearchParams(currentUrl.search)
      const id = searchParams.get('previewId')

      if (
        (href?.includes('events') ||
          to?.includes('events') ||
          as?.includes('events')) &&
        id
      ) {
        setPreviewId(id)
      }
    }
  }, [href, to, as, pid])

  // Standard link, use an `anchor` element
  if (href) {
    const newHref = previewId ? `${href}?previewId=${previewId}` : href
    return (
      <a
        className={className}
        ref={setRef}
        {...(!disabled && { href: newHref })}
        {...(disabled && { 'aria-disabled': 'true' })}
        {...(target && { target })}
        {...(target === '_blank' && { rel: 'noopener noreferrer' })}
        {...other}
      >
        {children}
      </a>
    )
  }

  // Internal link, use third-party `Link` component from router module
  if (to) {
    const newAs = previewId ? `${as}?previewId=${previewId}` : as
    return (
      <Link href={to} ref={setRef} as={newAs} prefetch={prefetch || false}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a className={className} role={role} {...other} target={target}>
          {children}
        </a>
      </Link>
    )
  }

  // No `href` or `to` means we need a `button` element
  return (
    <button
      className={className}
      type={type}
      ref={setRef}
      {...(disabled && { disabled })}
      {...other}
    >
      {children}
    </button>
  )
}

SmartLink.defaultProps = {
  type: 'button'
}

SmartLink.propTypes = {
  as: string,
  children: node,
  className: string,
  disabled: bool,
  href: string,
  role: string,
  setRef: func,
  target: string,
  to: string,
  prefetch: bool,
  type: oneOf(['button', 'reset', 'submit'])
}

export default SmartLink
